import ControllerBase from '../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import { OrganismShoppingCartEvents } from '../../organisms/o-shopping-cart/o-shopping-cart.events';
import { MoleculeProductProps } from './m-teaser-product.data';


/** A list of dom element references available to this component */
interface ComponentRefs {
	addToCart: 'addToCart',
	quantity: 'quantity',
}

// link types to molecule type, in case of changes in the future
type ProductId = MoleculeProductProps['productId'];

export default class ControllerProductTeaser extends ControllerBase<ComponentRefs> {


	/** The product ID */
	private readonly productId: ProductId;


	constructor(element: HTMLElement) {
		super(element);

		this.productId = this.$element.dataset.productid || '' as string;

		this.registerEventListeners();
	}

	private registerEventListeners(): void {
		this.registerAddToCartEvent();
	}

	/**
	 * Listen for clicks to the add to cart button
	 * @returns void
	 */
	private registerAddToCartEvent(): void {
		if (Object.prototype.hasOwnProperty.call(this.$references, this.$references.addToCart)) {
			/** Event handler for when the button is clicked */
			this.$references.addToCart && fromEvent(this.$references.addToCart, 'click')
				.subscribe((e: Event | MouseEvent) => {
					e.preventDefault();
					if (e && e.target) {
						const quantity = +(this.$references.quantity as HTMLInputElement).value;

						// build event data
						const eventDetail: {
							productId: string;
							quantity: number;
						} = {
							productId: this.productId,
							quantity: quantity,
						};
						this.dispatchCustomEvent(OrganismShoppingCartEvents.addToCart, eventDetail, true);
					}
				});
		}
	}

}
